<i18n src="./resources/locales.json"></i18n>
<template>
  <div ref="giphyContainer" class="giphy-container" :style="containerStyle">
    <SmsSearchInput ref="gifSearch" :placeholder="$t('search')" @input="value => (searchString = value)" />
    <v-virtual-scroll
      ref="scroll_area"
      :bench="3"
      :items="giphyRows"
      item-height="67"
      :height="380"
      class="render-images custom-scrollbar"
      @scroll="onScroll"
    >
      <template v-slot:default="{ item }">
        <v-row class="giphy-row" no-gutters>
          <SmsGiphyItem :gif="item[0]" small />
          <SmsGiphyItem :gif="item[1]" small />
          <SmsGiphyItem :gif="item[2]" small />
        </v-row>
      </template>
    </v-virtual-scroll>
  </div>
</template>
<script>
import SmsGiphyItem from './SmsGiphyItem';
import SmsSearchInput from '@/components/SmsSearchInput/SmsSearchInput';
import debounce from 'lodash/debounce';
import chunk from 'lodash/chunk';
import GiphyService from '@/api/services/GiphyService';

export default {
  name: 'SmsGiphyContainer',

  components: { SmsSearchInput, SmsGiphyItem },

  data() {
    return {
      gifList: [],
      searchString: '',
      lastOffset: 0,
      leftPosition: 0,
      resizeObserver: null
    };
  },

  computed: {
    containerStyle() {
      return {
        '--left-position': `${this.leftPosition}px`
      };
    },
    giphyRows() {
      return chunk(this.gifList, 3);
    }
  },

  mounted() {
    this.getGifs();
    this.resizeObserver = new ResizeObserver(this.setPosition).observe(this.$el.parentElement.parentElement);
    this.setPosition();
  },

  beforeDestroy() {
    delete this.resizeObserver;
  },

  created() {
    this.$root.$on('select-gif', this.clearSearch);
    this.$root.$on('clear-gif-search', this.clearSearch);
  },

  watch: {
    searchString() {
      this.getGifs();
    }
  },

  methods: {
    clearSearch() {
      this.$refs.gifSearch._forceClear();
      this._resetOffset();
    },
    getGifs: debounce( function() {
      this._resetOffset();
      const findGifs = this.searchString ? GiphyService.search(this.searchString) : GiphyService.getTrending();
      findGifs.then(response => (this.gifList = response));
    }, 250),
    setPosition() {
      const gifContainerRect = this.$el.getBoundingClientRect();
      if (gifContainerRect.right > document.body.clientWidth) {
        this.leftPosition = 16;
      } else {
        this.leftPosition = '';
      }
    },
    onScroll: debounce( function() {
      const vScroll = this.$refs.scroll_area;

      if (vScroll.lastToRender > this.lastOffset) {
        this.lastOffset = vScroll.lastToRender;
        if (this.searchString) {
          this.loadMoreSearch(this.searchString, vScroll.lastToRender * 3);
        } else {
          this.loadMoreTrending(vScroll.lastToRender * 3);
        }
      }
    }, 250),
    loadMoreSearch(searchString, offset) {
      GiphyService.search(searchString, offset).then(response => (this.gifList.push(...response)));
    },
    loadMoreTrending(offset) {
      GiphyService.getTrending(offset).then(response => (this.gifList.push(...response)));
    },
    _resetOffset() {
      this.lastOffset = 0;
    }
  }
};
</script>
<style scoped>
.giphy-container {
  width: 400px;
  max-width: calc(100% - 32px);
  height: 420px;
  background-color: var(--v-surface2-base) !important;
  border: solid 1px var(--v-surface-border-base) !important;
  position: absolute;
  bottom: 64px;
  left: var(--left-position);
  z-index: 1;
}
.render-images {
  overflow-y: scroll;
  max-height: 380px;
}
</style>
